export const frontendURL = "{frontendURL}";     // USE THIS WHILE PUSHING
export const backendURL = "{backendURL}";      // USE THIS WHILE PUSHING
export const backendApiURL = "{backendApiURL}";   // USE THIS WHILE PUSHING
export const authURL = "{authURL}";         // USE THIS WHILE PUSHING

/* POC */
// export const { frontendURL, backendURL, backendApiURL } = { 
//   frontendURL: "http://localhost:5173",
//   backendURL: "https://tildapoc.fi.se/prweb",
//   backendApiURL: "https://apimacc.fi.se/tildapoci/v1"
// };

/* DEV/UTV */
// export const frontendURL = "http://localhost:5173";
// export const { backendURL, backendApiURL, authURL } = {
//   backendURL: "https://tildawebutv.fi.se/prweb",
//   backendApiURL: "https://apimacc.fi.se/tildautv/v1",
//   authURL: "https://portalutv.finansinspektionen.se"
// };

/* TEST */
// export const frontendURL = "http://localhost:5173";
// export const { backendURL, backendApiURL, authURL } = {
//   backendURL: "https://api.test.fi.se/casemanagement/prweb",
//   backendApiURL: "https://apimacc.fi.se/tildatest/v1",
//   authURL: "https://portaltest.finansinspektionen.se"
// };

/* ACC */
// export const frontendURL = "http://localhost:5173";
// export const { backendURL, backendApiURL, authURL } = {
//   backendURL: "https://tildawebacc.fi.se/prweb",
//   backendApiURL: "https://apimacc.fi.se/tildaacc/v1",
//   authURL: "https://portalacc.finansinspektionen.se"
// };

/* PROD */
// export const frontendURL = "http://localhost:5173";
// export const { backendURL, backendApiURL } = {
//   backendURL: "https://tildaweb.fi.se/prweb",
//   backendApiURL: "https://apimacc.fi.se/tildaprod/v1"
// };

export const backendEnvs = {
  Pega: backendURL,
  API: backendApiURL,
}

// Add this command to every pipeline's deploy job to replace the environment variable with the relevant one
// sed -i 's/{frontendURL}/${frontendURL}/g' src/env/globalEnvConfig.ts
// sed -i 's/{backendURL}/${backendURL}/g' src/env/globalEnvConfig.ts
// sed -i 's/{backendApiURL}/${backendApiURL}/g' src/env/globalEnvConfig.ts
